import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Careers.css';

const Careers = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedType, setSelectedType] = useState('all');
  const [selectedDepartment, setSelectedDepartment] = useState('all');

  const jobOpenings = [
    {
      id: 1,
      title: 'Finance + HR Intern',
      department: 'Finance & Human Resources',
      type: 'Internship',
      location: 'Noida / Remote / Hybrid',
      stipend: '₹5,000/month',
      duration: '3-6 Months',
      description: 'Join our dynamic team as a Finance + HR Intern and gain hands-on experience in both finance operations and human resource management.',
      postedDate: '2024-01-15',
      applicants: 24
    },
    {
      id: 2,
      title: 'Full Stack Developer',
      department: 'IT Services',
      type: 'Full-Time',
      location: 'Noida / Hybrid',
      stipend: '₹6-10 LPA',
      duration: 'Permanent',
      description: 'We are looking for an experienced Full Stack Developer to join our growing development team and work on cutting-edge web applications.',
      postedDate: '2024-01-10',
      applicants: 42
    },
    {
      id: 3,
      title: 'Digital Marketing Specialist',
      department: 'Sales & Marketing',
      type: 'Full-Time',
      location: 'Noida / Remote',
      stipend: '₹4-7 LPA',
      duration: 'Permanent',
      description: 'Seeking a creative and data-driven Digital Marketing Specialist to develop and execute comprehensive digital marketing campaigns.',
      postedDate: '2024-01-12',
      applicants: 31
    }
  ];

  const departments = ['all', 'Finance & Human Resources', 'IT Services', 'Sales & Marketing', 'Data Engineering', 'AI Solutions'];
  const types = ['all', 'Full-Time', 'Internship', 'Contract', 'Part-Time'];

  const filteredJobs = jobOpenings.filter(job => {
    const matchesSearch = job.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         job.department.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         job.description.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesType = selectedType === 'all' || job.type === selectedType;
    const matchesDepartment = selectedDepartment === 'all' || job.department === selectedDepartment;
    
    return matchesSearch && matchesType && matchesDepartment;
  });

  const handleJobClick = (jobId) => {
    navigate(`/careers/${jobId}`);
  };

  const getTimeSincePosted = (date) => {
    const posted = new Date(date);
    const now = new Date();
    const days = Math.floor((now - posted) / (1000 * 60 * 60 * 24));
    
    if (days === 0) return 'Today';
    if (days === 1) return 'Yesterday';
    if (days < 7) return `${days} days ago`;
    if (days < 30) return `${Math.floor(days / 7)} weeks ago`;
    return `${Math.floor(days / 30)} months ago`;
  };

  return (
    <section className="careers" id="careers">
      <div className="container">
        <div className="careers-stats">
          <div className="stat-card">
            <div className="stat-icon">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="6" y="8" width="20" height="20" rx="2" stroke="currentColor" strokeWidth="2" fill="none"/>
                <path d="M12 8V6a2 2 0 012-2h4a2 2 0 012 2v2" stroke="currentColor" strokeWidth="2"/>
                <path d="M16 14v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </div>
            <div className="stat-content">
              <h3>{jobOpenings.length}</h3>
              <p>Open Positions</p>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 4v24M10 10l6-6 6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="16" cy="20" r="3" fill="currentColor"/>
              </svg>
            </div>
            <div className="stat-content">
              <h3>Fast Growth</h3>
              <p>Expanding Team</p>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="16" cy="12" r="4" stroke="currentColor" strokeWidth="2" fill="none"/>
                <path d="M8 26c0-4 4-7 8-7s8 3 8 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </div>
            <div className="stat-content">
              <h3>Great Culture</h3>
              <p>Work-Life Balance</p>
            </div>
          </div>
        </div>

        <div className="careers-filters">
          <div className="search-box">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="9" cy="9" r="6" stroke="currentColor" strokeWidth="2" fill="none"/>
              <path d="M14 14l4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
            <input
              type="text"
              placeholder="Search jobs by title, department, or keyword..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <div className="filter-group">
            <div className="filter-item">
              <label>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="3" y="4" width="12" height="10" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                  <path d="M6 4V3a1 1 0 011-1h4a1 1 0 011 1v1" stroke="currentColor" strokeWidth="1.5"/>
                </svg>
                Job Type
              </label>
              <select value={selectedType} onChange={(e) => setSelectedType(e.target.value)}>
                {types.map(type => (
                  <option key={type} value={type}>
                    {type === 'all' ? 'All Types' : type}
                  </option>
                ))}
              </select>
            </div>

            <div className="filter-item">
              <label>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 5h12M3 9h12M3 13h12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
                Department
              </label>
              <select value={selectedDepartment} onChange={(e) => setSelectedDepartment(e.target.value)}>
                {departments.map(dept => (
                  <option key={dept} value={dept}>
                    {dept === 'all' ? 'All Departments' : dept}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className="jobs-results">
          <div className="results-header">
            <h3>
              {filteredJobs.length} {filteredJobs.length === 1 ? 'Job' : 'Jobs'} Found
            </h3>
            {(searchTerm || selectedType !== 'all' || selectedDepartment !== 'all') && (
              <button 
                className="clear-filters"
                onClick={() => {
                  setSearchTerm('');
                  setSelectedType('all');
                  setSelectedDepartment('all');
                }}
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 4L4 12M4 4l8 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
                Clear Filters
              </button>
            )}
          </div>

          <div className="jobs-grid">
            {filteredJobs.length > 0 ? (
              filteredJobs.map(job => (
                <div key={job.id} className="job-card" onClick={() => handleJobClick(job.id)}>
                  <div className="job-card-header">
                    <div className="job-card-badges">
                      <span className={`badge badge-${job.type.toLowerCase().replace(/[- ]/g, '')}`}>
                        {job.type}
                      </span>
                      <span className="badge badge-time">{getTimeSincePosted(job.postedDate)}</span>
                    </div>
                    <div className="job-card-bookmark">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 4a2 2 0 012-2h6a2 2 0 012 2v14l-5-3-5 3V4z" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                      </svg>
                    </div>
                  </div>

                  <h3 className="job-card-title">{job.title}</h3>
                  <p className="job-card-description">{job.description}</p>

                  <div className="job-card-meta">
                    <span className="meta-item">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 5h8M4 8h8M4 11h5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                      </svg>
                      {job.department}
                    </span>
                    <span className="meta-item">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 2C5.5 2 3 4 3 6.5c0 3.5 5 7.5 5 7.5s5-4 5-7.5C13 4 10.5 2 8 2z" fill="currentColor" opacity="0.3"/>
                        <circle cx="8" cy="6.5" r="1.5" fill="currentColor"/>
                      </svg>
                      {job.location}
                    </span>
                    <span className="meta-item">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="8" cy="8" r="6" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                        <path d="M8 5v3l2 2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                      </svg>
                      {job.duration}
                    </span>
                  </div>

                  <div className="job-card-footer">
                    <div className="job-card-salary">
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 2v14M13 5H7.5a2.5 2.5 0 000 5h3a2.5 2.5 0 010 5H5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                      </svg>
                      {job.stipend}
                    </div>
                    <div className="job-card-applicants">
                      {job.applicants} applicants
                    </div>
                  </div>

                  <button className="job-card-apply">
                    View Details
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6 3l5 5-5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                </div>
              ))
            ) : (
              <div className="no-results">
                <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="28" cy="28" r="18" stroke="currentColor" strokeWidth="3" fill="none"/>
                  <path d="M42 42l14 14" stroke="currentColor" strokeWidth="3" strokeLinecap="round"/>
                  <path d="M28 20v16M20 28h16" stroke="currentColor" strokeWidth="3" strokeLinecap="round"/>
                </svg>
                <h3>No Jobs Found</h3>
                <p>Try adjusting your search or filters to find what you're looking for.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Careers;
